import { pressArticles } from '../pressArticles';

import styles from './PressCards.module.css';

/**
 * Responsive grid of press-coverage cards (two columns on desktop, one on
 * mobile). Each card is a single external link to the article. Converted from
 * the Head of Humanities' handoff component to our CSS Modules + design tokens;
 * hover is handled in CSS (no JS state). The article list lives in
 * ../pressArticles.ts.
 */
export function PressCards() {
  return (
    <ul className={styles.grid}>
      {pressArticles.map((article) => (
        <li key={article.id}>
          <a
            className={styles.card}
            href={article.url}
            rel="noopener noreferrer"
            target="_blank"
          >
            <span className={styles.logoBox}>
              <img
                alt={article.publication}
                className={styles.logo}
                loading="lazy"
                src={article.logo}
              />
            </span>

            <span className={styles.body}>
              <span className={styles.top}>
                <span className={styles.publication}>{article.publication}</span>
                <svg
                  aria-hidden="true"
                  className={styles.arrow}
                  fill="none"
                  height="14"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2.2"
                  viewBox="0 0 24 24"
                  width="14"
                >
                  <path d="M5 12h14" />
                  <path d="m12 5 7 7-7 7" />
                </svg>
              </span>
              <span className={styles.title}>{article.title}</span>
              <span className={styles.date}>{article.date}</span>
            </span>
          </a>
        </li>
      ))}
    </ul>
  );
}
